export const SERIES_CHATS_CLOSE_AFTER_DAYS = 7
export const SERIES_RESERVATION_HOLD_HOURS = 48
export const SERIES_RESERVATIONS_MAX = 2
